import { createFileRoute } from '@tanstack/react-router';
import { CalendarScreen } from '../../screens/Calendar';

export const Route = createFileRoute('/tasks/calendar')({
  component: CalendarScreen,
});
